var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageDefaultRadius warning",class:_vm.halfRadius ? 'pageHalfRadius' : ''},[_c('i',{staticClass:"iconfont icongantanhao"}),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }